import { MissionGroup } from '../objects/MissionGroup';

angular.module("tromanWeb").factory('MissionGroupState', ['$q', 'tromanServer', 'dialogService', function ($q, tromanServer, dialogService) {

    function load(id) {
        if (id) {
            return tromanServer.MissionGroups.get(id);
        } else {
            return $q.when(new MissionGroup());
        }
    }

    class MissionGroupState {
        constructor(missionGroup) {
            this.missionGroup = missionGroup;
        }

        static create(id) {
            return load(id)
                .then(x => new MissionGroupState(x))
                .catch(err => {
                    dialogService.error(err);
                    return $q.reject(err);
                });
        }
    }

    return MissionGroupState;
}]);
